if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.swapElementMobile();
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      swapElementMobile() {
        const listChild = Array.from(this.children);
        const currentIndexAction = listChild.findIndex((child) => child.classList.contains('product__action'));
        const currentElmAction = listChild.find((child) => child.classList.contains('product__action'));

        const moveElm = () => {
          let index =
            window.innerWidth < 990
              ? listChild.findIndex(
                  (child) =>
                    child.classList.contains('product__description') || child.classList.contains('product__accordions')
                )
              : currentIndexAction;

          currentElmAction && this.insertBefore(currentElmAction, this.children[index]);
        };

        moveElm();
        window.addEventListener('resize', () => moveElm());
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay') &&
          this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay') &&
              this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

if (!customElements.get('product-sticky')) {
  customElements.define(
    'product-sticky',
    class ProductSticky extends HTMLElement {
      constructor() {
        super();
        this.main = this.querySelector('.product__action-sticky-main');
        this.announcementBar = document.querySelector('.shopify-section.announcement-bar-section');
        this.documentHeader = document.querySelector('.shopify-section.section-header');
        this.stickyShowing = false;
        this.footerInView = false;
        // this.createObserver();
        this.createObserverFooter(); // Hide sticky section when showing footer
        window.addEventListener('scroll', this.checkVisibilityElement.bind(this));
        window.addEventListener('resize', this.checkVisibilityElement.bind(this));
        this.checkVisibilityElement();
      }
      checkVisibilityElement() {
        let heightAnnouncementBar = this.announcementBar.offsetHeight || 0;
        let heightDocumentHeader = this.documentHeader.offsetHeight || 0;
        let heightTop = heightAnnouncementBar + heightDocumentHeader;
        this.mainDefault = document.querySelector("[data-type='product-action']");
        if (this.mainDefault) {
          let { height, top } = this.mainDefault.getBoundingClientRect();
          this.handleInView(heightTop > top + height && this.footerInView == false);
        }
      }
      createObserver() {
        let heightAnnouncementBar = this.announcementBar.offsetHeight || 0;
        let heightDocumentHeader = this.documentHeader.offsetHeight || 0;
        let heightTop = (heightAnnouncementBar + heightDocumentHeader) * -1 + 'px';
        console.log(heightTop);
        const options = {
          root: null,
          rootMargin: `${heightTop} 0px 0px 0px`,
          threshold: 1,
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            try {
              // when default element run out of screen and screen at the bottom default element is showing sticky element
              const showSticky = entry.isIntersecting == false && entry.boundingClientRect.top < entry.rootBounds.top;
              this.stickyShowing = showSticky;
              this.handleInView(showSticky).bind(this);
            } catch (error) {}
          });
        }, options);
        observer.observe(this.mainDefault);
      }
      createObserverFooter() {
        const footer = document.querySelector('.shopify-section-group-footer-group');
        const options = {
          root: null,
          rootMargin: `0px`,
          threshold: 1,
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            try {
              this.footerInView = entry.isIntersecting;
              // if not see footer is SHOWING sticky element
              // if not see footer and not showing stick element is NOT SHOWING sticky element
              // if see footer and not showing stick element is NOT SHOWING sticky element
              // if see footer and show sticky element is NOT SHOWING sticky element
              // let stickyShouldShowing = !entry.isIntersecting && this.stickyShowing == true;
              // this.stickyShowing = !stickyShouldShowing;
              // this.handleInView(!entry.isIntersecting).bind(this);
              window.scrollTo({ top: window.scrollY - 1 });
            } catch (error) {}
          });
        }, options);
        observer.observe(footer);
      }
      handleInView(showSticky) {
        // true is show sticky, false is hide sticky
        this.keepSpace(showSticky);
        this.moveElement(showSticky);
        this.classList.toggle('show', showSticky);
      }
      keepSpace(showSticky) {
        this.mainDefault.classList.toggle('keep-space', showSticky);
        this.mainDefault.style.height = showSticky ? this.mainDefault.scrollHeight + 'px' : '';
      }
      moveElement(showSticky) {
        const fromElement = showSticky ? this.mainDefault : this.main;
        const toElement = showSticky ? this.main : this.mainDefault;
        while (fromElement.childNodes.length > 0) toElement.appendChild(fromElement.childNodes[0]);
      }
    }
  );
}
